var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3216_2782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50771 5.08806V4.25049M8.50771 5.08806C9.99114 5.08806 10.6983 5.8172 10.6983 6.67677M8.50771 5.08806C7.02271 5.08806 6.31714 5.77477 6.31714 6.67677C6.31714 7.3792 7.02428 8.05492 8.50771 8.26706C9.99271 8.4792 11.033 8.96792 11.033 10.0271C11.033 10.9825 9.99271 11.7823 8.50771 11.7823C7.02271 11.7823 5.98242 11.1003 5.98242 10.1921M8.50771 12.6215V11.7855",
    stroke: "#2563EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8554 10.6762C16.0041 9.98893 16.0785 9.24197 16.0785 8.43531C16.0785 3.58431 13.3505 0.854736 8.49952 0.854736C3.64852 0.854736 0.918945 3.58431 0.918945 8.43531C0.918945 12.1062 2.48252 14.5607 5.34566 15.5382M6.3278 21.145C6.3278 21.145 10.0348 16.2469 11.6785 16.3805C12.9985 16.4873 13.1164 19.2939 14.3405 18.7879C15.1577 18.45 19.8154 14.2244 20.9609 13.1779",
    stroke: "#2563EB",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.043 12.8273C18.2624 12.5225 19.8464 12.6451 21.003 13.1338C21.3078 14.3516 21.1853 15.9356 20.6981 17.0938",
    stroke: "#2563EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3216_2782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.db7dae1891a573ad6f8889b92b53d489.svg";
export { ForwardRef as ReactComponent };